import React from 'react'

function Footer() {
    return (
        <footer className="footer__container">
            <div>
                <p>©2021 Art Tender</p>
            </div>
            <div>
                <a href="mailto:arttender21@gmail.com">Get in touch</a>
            </div>
        </footer>
    )
}

export default Footer
